var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$apollo.loading)?_c('Loading'):[_c('v-tabs-items',{staticClass:"button-edit__tabs-items",model:{value:(_vm.currentTab),callback:function ($$v) {_vm.currentTab=$$v},expression:"currentTab"}},[_c('v-tab-item',{staticClass:"mx-2",attrs:{"value":"component"}},[_c('Fields',{attrs:{"schema":{
            name: {
              type: 'string',
              label: 'Nombre',
              description: 'Debe ser único y reconocible.',
              sizeSmall: 12,
              sizeLarge: 6,
              newDesign: true
            },
            title: {
              type: 'string',
              label: 'Título',
              description: 'Opcional. Se mostrará en las vistas.',
              sizeSmall: 12,
              sizeLarge: 6,
              optional: true,
              newDesign: true
            },
            roles: {
              type: 'roleSelect',
              __graphQLType: '[ID]',
              label: 'Roles',
              fieldOptions: {
                multi: true
              },
              optional: true,
              newDesign: true
            },
            buttonType: {
              type: 'select',
              label: 'Tipo de Botón',
              fieldOptions: {
                options: [
                  { label: 'Acción (ejecutar hooks)', value: 'button' },
                  { label: 'HSM', value: 'hsm' },
                  {
                    label: 'Request POST con datos (desde navegador)',
                    value: 'postItemToUrl'
                  }
                ],
                sizeSmall: 12
              },
              newDesign: true
            }
          },"disabled":_vm.$apollo.loading || _vm.saving,"environment-variables":{ environmentId: _vm.environmentId },"validationErrors":{}},model:{value:(_vm.button),callback:function ($$v) {_vm.button=$$v},expression:"button"}})],1),_c('v-tab-item',{staticClass:"mx-2",attrs:{"value":"appearance"}},[_c('v-card-text',[_c('v-layout',{staticClass:"elevation-2 pa-4 ma-1",staticStyle:{"padding":"16px"},attrs:{"align-center":"","justify-center":""}},[_c('v-btn',{style:(_vm.button.largeHitbox && _vm.button.style !== 'fab'
                  ? { flex: '1' }
                  : {}),attrs:{"color":_vm.button.color || 'primary',"dark":_vm.button.color &&
                (_vm.button.style === 'normal' || _vm.button.style === 'fab'),"text":_vm.button.style === 'flat',"outlined":_vm.button.style === 'outline',"fab":_vm.button.style === 'fab',"x-large":_vm.button.largeHitbox}},[(_vm.button.icon)?_c('v-icon',{attrs:{"left":_vm.button.buttonText && _vm.button.style !== 'fab'},domProps:{"textContent":_vm._s(_vm.normalizedIcon)}}):_vm._e(),(_vm.button.buttonText && _vm.button.style !== 'fab')?_c('span',[_vm._v(_vm._s(_vm.button.buttonText))]):_vm._e()],1)],1)],1),_c('Fields',{attrs:{"schema":{
            buttonText: {
              type: 'string',
              label: 'Texto del botón',
              sizeSmall: 12,
              sizeLarge: 6,
              optional: true,
              newDesign: true
            },
            style: {
              type: 'select',
              label: 'Estilo',
              fieldOptions: {
                options: [
                  { label: 'Normal', value: 'normal' },
                  { label: 'Flat', value: 'flat' },
                  { label: 'Outline', value: 'outline' },
                  { label: 'Circular (sólo ícono)', value: 'fab' }
                ]
              },
              sizeSmall: 12,
              sizeLarge: 6,
              newDesign: true
            },
            largeHitbox: {
              type: 'checkbox',
              label: 'Expandir botón a su contenedor.',
              sizeSmall: 12,
              sizeLarge: 12,
              optional: true,
              newDesign: true
            },
            icon: {
              type: 'string',
              label: 'Ícono',
              description:
                'Visitar https://material.io/icons para una lista de íconos.',
              sizeSmall: 12,
              sizeLarge: 4,
              optional: true,
              newDesign: true
            },
            color: {
              type: 'string',
              fieldType: 'color',
              label: 'Color Personalizado',
              description: 'Por defecto se usará el color primario del tema.',
              sizeSmall: 12,
              sizeLarge: 4,
              optional: true,
              newDesign: true
            }
          },"disabled":_vm.$apollo.loading || _vm.saving,"validationErrors":{}},model:{value:(_vm.button),callback:function ($$v) {_vm.button=$$v},expression:"button"}})],1),_c('v-tab-item',{staticClass:"mx-2",attrs:{"value":"actions"}},[_c('v-card-text',[_c('Fields',{staticClass:"button-edit__tab-actions-1",attrs:{"schema":{
              firstHook: {
                type: 'string',
                label:
                  'Hook a ejecutar antes de las demás acciones (pre-hook).',
                fieldType: 'hookSelect',
                sizeSmall: 12,
                optional: true,
                newDesign: true
              },
              afterHooksIds: {
                type: 'array',
                label: 'Hooks a ejecutar',
                fieldType: 'hookSelect',
                fieldOptions: {
                  multi: true
                },
                sizeSmall: 12,
                optional: true
              },
              lastHook: {
                type: 'string',
                label:
                  'Hook a ejecutar después de las demás acciones (post-hook)',
                fieldType: 'hookSelect',
                sizeSmall: 12,
                optional: true,
                newDesign: true
              },
              requireConfirmation: {
                type: 'checkbox',
                label: 'Requiere confirmación',
                sizeSmall: 12,
                optional: true,
                newDesign: true
              },
              confirmationText: {
                type: 'string',
                label: 'Texto de confirmación',
                sizeSmall: 12,
                optional: true,
                newDesign: true,
                fieldOptions: {
                  placeholder: '¿Estás seguro?'
                }
              },
              onSuccessMessage: {
                type: 'string',
                label: 'Mensaje a mostrar tras ejecución exitosa de acciones',
                optional: true,
                sizeSmall: 12,
                sizeLarge: 12,
                newDesign: true
              },
              onErrorMessage: {
                type: 'string',
                label: 'Mensaje a mostrar tras error',
                optional: true,
                sizeSmall: 12,
                sizeLarge: 12,
                newDesign: true
              }
            },"environmentVariables":{ environmentId: _vm.environmentId, buttonId: _vm.componentId },"disabled":_vm.$apollo.loading || _vm.saving,"validationErrors":{}},model:{value:(_vm.button),callback:function ($$v) {_vm.button=$$v},expression:"button"}}),_c('label',{staticClass:"subtitle-1"},[_c('v-icon',{attrs:{"left":""}},[_vm._v("select_all")]),_vm._v("Parámetros de la vista a pasar a los hooks")],1),_c('br'),_c('KeyValueList',{staticStyle:{"padding-left":"32px"},attrs:{"array":"","keyLabel":"Parámetro","keyField":"parameterName"},model:{value:(_vm.button.parameters),callback:function ($$v) {_vm.$set(_vm.button, "parameters", $$v)},expression:"button.parameters"}}),_c('span',{staticStyle:{"margin-left":"24px","padding":"8px","display":"inline-block","opacity":"0.75"}},[_vm._v(" NOTA: Si se quiere usar el botón por si sólo para ejecutar hooks (no en una tabla), se debe especificar un parámetro llamado \"_id\" y en valor el nombre de algún parámetro que posea la vista (si el valor entregado no existe como parámetro en la vista, este se interpreta como un valor fijo) ")]),_c('br'),_c('br'),_c('label',{staticClass:"subtitle-1"},[_c('v-icon',{attrs:{"left":""}},[_vm._v("low_priority")]),_vm._v("Resultados a utilizar")],1),_c('div',{staticStyle:{"padding-left":"32px"}},[_c('ul',[_c('li',[_vm._v(" Para operaciones batch, usar los campos del item Nº "),_c('v-text-field',{staticStyle:{"display":"inline-block","width":"4em"},attrs:{"min":"0","dense":"","type":"number"},model:{value:(_vm.button.itemNumberResult),callback:function ($$v) {_vm.$set(_vm.button, "itemNumberResult", $$v)},expression:"button.itemNumberResult"}}),_vm._v(" para acciones posteriores (por defecto se usa el último) ")],1),_c('li',[_vm._v(" Usar los resultados del hook Nº "),_c('v-text-field',{staticStyle:{"display":"inline-block","width":"4em"},attrs:{"dense":"","min":"0","type":"number"},model:{value:(_vm.button.hookResult),callback:function ($$v) {_vm.$set(_vm.button, "hookResult", $$v)},expression:"button.hookResult"}}),_vm._v(" para acciones posteriores (por defecto se usa el último) ")],1)])]),_c('label',{staticClass:"subtitle-1"},[_c('v-icon',{attrs:{"left":""}},[_vm._v("select_all")]),_vm._v("Parámetros de resultado de hooks a pasar a la vista")],1),_c('br'),_c('KeyValueList',{staticStyle:{"padding-left":"32px"},attrs:{"array":"","keyLabel":"Parámetro Resultado","keyField":"parameterName","valueLabel":"Parámetro Vista"},model:{value:(_vm.button.setViewParameters),callback:function ($$v) {_vm.$set(_vm.button, "setViewParameters", $$v)},expression:"button.setViewParameters"}}),_c('v-slide-y-transition',[(_vm.button.buttonType === 'postItemToUrl')?_c('TextInput',{key:"postItemToUrl",attrs:{"name":"postItemToUrl","schema":{
                label: 'Enviar resultado a esta URL al finalizar',
                description:
                  'Se realizará una solicitud POST con los campos en formato JSON',
                optional: true
              }},model:{value:(_vm.button.postItemToUrl),callback:function ($$v) {_vm.$set(_vm.button, "postItemToUrl", $$v)},expression:"button.postItemToUrl"}}):_vm._e()],1),_c('v-slide-y-transition',[(_vm.button.buttonType === 'hsm')?_c('Fields',{key:"hsm",staticClass:"button-edit__tab-actions-2",attrs:{"schema":{
                hsmHookId: {
                  type: 'string',
                  label: 'HSM Hook ID',
                  fieldType: 'hookSelect',
                  sizeSmall: 12,
                  optional: true,
                  newDesign: true
                }
              },"environmentVariables":{ environmentId: _vm.environmentId, buttonId: _vm.componentId },"disabled":_vm.$apollo.loading || _vm.saving,"validationErrors":{}},model:{value:(_vm.button),callback:function ($$v) {_vm.button=$$v},expression:"button"}}):_vm._e()],1),_c('v-row',{attrs:{"no-gutters":true}},[_c('v-col',{staticClass:"pa-0",attrs:{"cols":"12"}},[_c('CheckBox',{attrs:{"name":"requireTwoFactor","schema":{
                  label: 'Interrumpir acciones si ocurre un error',
                  optional: true,
                  newDesign: true
                }},model:{value:(_vm.button.shouldStopHooksOnError),callback:function ($$v) {_vm.$set(_vm.button, "shouldStopHooksOnError", $$v)},expression:"button.shouldStopHooksOnError"}})],1),_c('v-col',{staticClass:"pa-0",attrs:{"cols":"12"}},[_c('CheckBox',{attrs:{"name":"requireTwoFactor","schema":{
                  label:
                    'Requerir Autenticación de 2 factores antes de ejecutar las acciones',
                  optional: true,
                  newDesign: true
                }},model:{value:(_vm.button.requireTwoFactor),callback:function ($$v) {_vm.$set(_vm.button, "requireTwoFactor", $$v)},expression:"button.requireTwoFactor"}})],1),_c('v-col',{staticClass:"pa-0",attrs:{"cols":"12"}},[_c('CheckBox',{attrs:{"name":"goBack","schema":{
                  label: 'Volver a la vista anterior al finalizar',
                  optional: true,
                  newDesign: true
                }},model:{value:(_vm.button.goBack),callback:function ($$v) {_vm.$set(_vm.button, "goBack", $$v)},expression:"button.goBack"}})],1)],1),_c('v-slide-y-transition',[(!_vm.button.goBack)?_c('TextInput',{attrs:{"name":"url","schema":{
                label: 'Redireccionar a esta vista o URL al finalizar',
                description:
                  'Para insertar parámetros, usa :nombreParametro (ej. /clientes/:clienteId)',
                fieldOptions: {
                  placeholder: '/vista/:parametro'
                },
                optional: true,
                newDesign: true
              }},model:{value:(_vm.button.url),callback:function ($$v) {_vm.$set(_vm.button, "url", $$v)},expression:"button.url"}}):_vm._e()],1)],1)],1)],1),_c('v-card-actions',[_c('v-btn',{attrs:{"text":"","icon":"","color":"error","disabled":_vm.$apollo.loading || _vm.saving,"title":"Eliminar Botón"},on:{"click":_vm.deleteItem}},[_c('v-icon',[_vm._v("delete")])],1),_c('v-btn',{attrs:{"text":"","icon":"","title":"Revertir Cambios","disabled":!_vm.dirty || _vm.saving},on:{"click":_vm.update}},[_c('v-icon',[_vm._v("undo")])],1),_c('v-flex'),_c('v-btn',{attrs:{"color":"#59a4f4","dark":"","disabled":_vm.$apollo.loading || _vm.saving},on:{"click":_vm.dismiss}},[_vm._v("Cancelar")]),_c('v-btn',{attrs:{"color":"#59a4f4","dark":!_vm.dirty ? false : true,"disabled":!_vm.dirty,"loading":_vm.$apollo.loading || _vm.saving},on:{"click":_vm.save}},[_vm._v("Guardar")])],1)]],2)}
var staticRenderFns = []

export { render, staticRenderFns }